import {Col, Container, Modal, Row} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import {connectCompanyExtApp, createCompanyExtAppTerminal, syncCompanyExtAppTerminal} from "../common/api/WebApi";
import {CONSTANTS} from "../common/constants";
import {AppContext} from "../../lib/AppContext";
import {formatDisplayMinutes} from "../common/Utils";

export default function SyncSquareDeviceModal({handleClose, handleSave, show}) {

  const [context, setContext] = useContext(AppContext);
  const [locations, setLocations] = useState([]);
  const [squareConnected, setSquareConnected] = useState(false);

  const [formInvalid, setFormInvalid] = useState(false);
  const [saving, setSaving] = useState(false);

  const getCompanyExtAppData = () => {
    connectCompanyExtApp().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setLocations(result);
        if (result?.type == CONSTANTS.EXT_APPLICATION.SQUARE) {
          setSquareConnected(true);
        }
      }
    });
  }

  useEffect(() => {
    getCompanyExtAppData();
  }, [])

  const handleFormChange = (e) => {
    setValue(e.target.name, e.target.value);
  };

  const {register, handleSubmit, setValue, control} = useForm({});
  const [deviceTimer, setDeviceTimer] = useState(0);

  useEffect(() => {
    if (deviceTimer > 0) {
      const timerId = setInterval(() => {
        setDeviceTimer((prevSeconds) => prevSeconds - 1);
      }, 1000);
      return () => clearInterval(timerId); // Cleanup on unmount or update
    }
  }, [deviceTimer]);

  const [syncingDevice, setSyncingDevice] = useState(false);
  const [activeDevice, setActiveDevice] = useState();

  const createCompanyExtAppTerminalFn = (app) => {
    setSyncingDevice(true);
    setActiveDevice(null);
    createCompanyExtAppTerminal(app).then((resp) => {
      setActiveDevice(resp);
      setDeviceTimer(60 * 5);
    });
  }

  const handleSync = async () => {
    syncCompanyExtAppTerminal(activeDevice).then((resp) => {
      handleSave()
    });
  }

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form onSubmit={handleSubmit(handleSync)} id={'squareSyncForm'}>
        <Modal.Header closeButton>
          <Modal.Title>Manage Point of Sale</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                {!syncingDevice && <Row>
                  <Col className={'col'} sm={12}>
                    {locations?.availableLocations?.length > 0 && <>
                      <MDTypography variant="h6">
                        Square Locations
                      </MDTypography>
                      <table className="table table-striped mt-2 mb-4">
                        <thead>
                        <tr>
                          <th>Name</th>
                          <th className={'text-right'}>Sync</th>
                        </tr>
                        </thead>
                        <tbody>
                        {locations?.availableLocations?.map((a, idx) => {
                          return (
                            <tr key={idx}>
                              <td>{a.name}</td>
                              <td className={'text-right'}>
                                <MDButton
                                  color="secondary"
                                  size="small"
                                  onClick={() => {
                                    createCompanyExtAppTerminalFn(a);
                                  }}>Sync Device</MDButton>
                              </td>
                            </tr>
                          )
                        })}
                        </tbody>
                      </table>
                    </>
                    }
                  </Col>
                </Row>
                }
                {syncingDevice && <Row>
                  {!activeDevice && <Col className={'col col-12'} sm={12}>
                    <p style={{
                      textAlign:'center',
                    }}>Connecting to Square Device Token...</p>
                  </Col>}

                  {activeDevice?.location &&

                    <Col className={'col col-12'} sm={12}>
                      <MDTypography variant="h5" fontWeight="regular" style={{
                        display: 'block',
                        marginBottom: '15px'
                      }}>{activeDevice?.location}</MDTypography>

                      <MDTypography variant="p" fontWeight="regular">
                        Sign in to your Square terminal device with 'Use a device code' and
                        enter the following code. Once finished, Save below.
                        <br/>
                        <b>Note:</b> Code will expire in {formatDisplayMinutes(deviceTimer)}
                      </MDTypography>
                      <MDTypography variant="h4" fontWeight="bold" style={{
                        textAlign: 'center',
                        display: 'block',
                        marginBottom: '15px'
                      }}>
                        <span> {activeDevice?.deviceCode} </span>
                      </MDTypography>
                      {deviceTimer <= 0 && <p style={{
                        textAlign: 'center'
                      }}>
                        <small>this code has expired</small>
                      </p>}
                    </Col>
                  }
                </Row>}

              </Container>
            </Col>
          </Row>


        </Modal.Body>
        <Modal.Footer>
          {activeDevice && <MDButton type="submit" color="info">
            {saving ? 'Saving...' : 'Save'}
          </MDButton>}
        </Modal.Footer>
      </form>
    </Modal>
  );
}